import { DealData, DealStage } from "@/pages/deals/types";
import { GuardrailsErrorResponse } from "./types";
import { find } from "lodash";

export const isCompletedWorkflowsError = (
  errorData: GuardrailsErrorResponse | string | null
): boolean => {
  if (typeof errorData !== "string") return false;
  const cleanedError = errorData.replace(/^\d+\s+/, "");
  return (
    cleanedError.includes("You've completed all required workflows for") &&
    cleanedError.includes("but you can't move directly to")
  );
};

export const getCleanedErrorMessage = (
  errorData: GuardrailsErrorResponse | string | null
): string | null => {
  if (typeof errorData !== "string") return null;
  return errorData.replace(/^\d+\s+/, "");
};

export const getNextStage = (
  dealData: DealData | null,
  stages: DealStage[] | undefined
): DealStage | null => {
  if (!dealData?.stage || !stages) return null;

  const currentStage = find(stages, (stage) => stage.id === dealData.stage);
  if (!currentStage) return null;

  const nextStage = find(
    stages,
    (stage) => stage.stageOrder === currentStage.stageOrder + 1
  );

  return nextStage || null;
};

export const parseErrorData = (
  errorData: GuardrailsErrorResponse | string | null
): GuardrailsErrorResponse | null => {
  if (!errorData) return null;
  if (typeof errorData === "object") return errorData;
  try {
    // Remove HTTP status code prefix (e.g., "400 ")
    const jsonString = errorData.replace(/^\d+\s+/, "");

    // Replace single quotes with double quotes for valid JSON
    const validJsonString = jsonString.replace(/'/g, '"');

    return JSON.parse(validJsonString);
  } catch (error) {
    console.error("Failed to parse error data:", error);
    return null;
  }
};
